import { MDCTabBar } from '@material/tab-bar'
export default {
  name: 'tabs',
  props: {
    initialTab: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    isMounted: false,
    currentTab: 0,
    tabsEl: null,
    tabsComponent: null
  }),
  computed: {
    scope() {
      return {
        currentTab: this.currentTab,
        isMounted: this.isMounted
      }
    }
  },
  created() {
    this.currentTab = this.initialTab
  },
  mounted() {
    this.tabsEl = this.$el.querySelector('.mdc-tab-bar')
    this.tabsComponent = new MDCTabBar(this.tabsEl)
    this.tabsComponent.activateTab(this.currentTab)
    this.tabsComponent.focusOnActivate = false;
    this.tabsEl.addEventListener('MDCTabBar:activated', this.tabChange)
    this.isMounted = true
  },
  methods: {
    tabChange(e) {
      this.currentTab = e.detail.index
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}